import type { SxProps, Theme } from '@mui/material/styles';

export const rootSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 2,
};

export const iconWrapperSx = (bgColor: string): SxProps<Theme> => ({
  width: 32,
  height: 32,
  borderRadius: '50%',
  backgroundColor: bgColor,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '@media (max-width: 425px)': {
    width: 28,
    height: 28,
  },
});

export const textSx: SxProps<Theme> = {
  fontSize: 24,
  '@media (max-width: 425px)': {
    fontSize: 18,
  },
};
